/**
 * TanStack Query provider setup with global error handling.
 *
 * Configures QueryClient with retry/cache defaults, wires onQueryError
 * to QueryCache and MutationCache for Sentry reporting of server errors.
 * Wraps children in PostHog and QueryClientProvider.
 */

import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { PostHogProvider } from "@/integrations/posthog/provider";
import { onQueryError, queryConfig } from "@/lib/errors/query-config";

// Module-level reference for logout to clear cache
let queryClientInstance: QueryClient | null = null;

export function getQueryClient(): QueryClient | null {
	return queryClientInstance;
}

export function getContext() {
	const queryClient = new QueryClient({
		defaultOptions: queryConfig,
		queryCache: new QueryCache({ onError: onQueryError }),
		mutationCache: new MutationCache({ onError: onQueryError }),
	});
	queryClientInstance = queryClient;
	return {
		queryClient,
	};
}

export function Provider({
	children,
	queryClient,
}: {
	children: React.ReactNode;
	queryClient: QueryClient;
}) {
	return (
		<PostHogProvider>
			<QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
		</PostHogProvider>
	);
}
